// lib
import React from "react";
import PropTypes from "prop-types";
import { IconButton, List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { Add } from "@material-ui/icons";

const People = ({ createHandleSelect, items, selfTranslate }) => {
  if (!items) return null;
  return (
    <>
      <List dense>
        {items.map((item) => (
          <ListItem key={item.id}>
            <ListItemIcon onClick={createHandleSelect(item)}>
              <IconButton size="small" className="add">
                <Add />
              </IconButton>
            </ListItemIcon>
            <ListItemText primary={selfTranslate(item.display)} />
          </ListItem>
        ))}
      </List>
    </>
  );
};

People.propTypes = {
  // from parent
  createHandleSelect: PropTypes.func.isRequired,
  selfTranslate: PropTypes.func.isRequired,
  items: PropTypes.array,
};

People.defaultProps = {
  items: [],
};

export default People;
